/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_DateInputs */

const vi_tea_package_date = /** @type {(inputs: Tea_Package_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày đóng gói`)
};

/**

* @param {Tea_Package_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_date = /** @type {((inputs?: Tea_Package_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_date(inputs)
});